var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { TextInput } from "grommet";
export var StyledTextInput = styled(TextInput)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  border: none;\n  width: 218px;\n  height: 35px;\n",
    ]))
);
